import { fontStyles } from '@/styles/typography';

import { GasPumpIcon } from '@/ui/Icons/GasPumpIcon';
import { RocketIcon } from '@/ui/Icons/RocketIcon';
import { SwapIcon } from '@/ui/Icons/SwapIcon';

const MARKETING_CARDS = [
  {
    icon: RocketIcon,
    title: 'Every DEX, Every Launchpad',
    body: 'No matter where the liquidity is: an AMM, propAMM, RFQ, or a pre-graduation bonding curve, Matcha has it all.',
  },
  {
    icon: SwapIcon,
    title: 'Instant Cross Chain Bridging',
    body: 'No funds on Robinhood or BSC or Solana? No problem. Bridge instantly to every chain.',
  },
  {
    icon: GasPumpIcon,
    title: 'Gasless Swaps',
    body: "Don't think about gas and don't pay for reverts. Just swap.",
  },
];

export const MarketingStrip = () => (
  <div className="flex flex-col tablet:flex-row gap-3">
    {MARKETING_CARDS.map(({ icon: Icon, title, body }) => (
      <div
        key={title}
        className="flex flex-col gap-2 rounded-2xl bg-special-background-card p-5 flex-1 min-w-[220px]"
      >
        <Icon className="text-token-green-1000" width={20} height={20} />
        <span className={fontStyles({ variant: 'LABEL_MD' })}>{title}</span>
        <span className={fontStyles({ variant: 'BODY_SM', class: 'text-token-gray-700' })}>
          {body}
        </span>
      </div>
    ))}
  </div>
);
